// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"65":"cdc31096","288":"4c83d99e","424":"315475bc","589":"81846587","592":"45dafcae","691":"1181d699","717":"0560df4d","720":"f1ff96e7","777":"d0a8bbb0","817":"6e0447a7","830":"3259cb22","977":"493e818d"}[chunkId] + ".js";
};